import React from 'react';
import { FicheAutocontrole, FicheAutocontroleActionTypes, FicheAutoControleCritere, FicheAutocontroleTabReserves } from '../../store/types/FicheAutocontrole.Types';
import { GeneralInformationsState, GeneralInformationsTypes } from '../../store/types/generalInformations.Types';
import { ApplicationState } from '../../store/store/store';
import { connect } from 'react-redux';
import { Button, CircularProgress } from '@material-ui/core';
import { makeStyles, Theme, createStyles, Backdrop } from '@material-ui/core';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { API } from '../../utils/callAPI';
import { uploadToS3 } from '../../utils/upload.image.s3.service';
import { OldPictureTypes, PictureState, PictureTypes } from '../../store/types/pictures.Types';
import { CurrentState, CurrentStateActions } from '../../store/types/CurrentState.Types';
import { GoBackCurrentStateActions } from '../../store/types/GoBackState.Types';
import ProgressBarService from '../../utils/progressBar.service';
import { MessagesAlertState, MessagesAlertTypes } from '../../store/types/MessagesAlert.Types';
import { TabSynthese, TabSyntheseStateActions } from '../../store/types/TabSynthese.Types';
import { tabInfosToGeneralInformations } from '../../utils/mappers/generalInformationsMapper';
import ReserveAutocontrole from '../Criteres/TypesCriteres/ReserveAutocontrole';
import { ReInitPicCompActions } from '../../store/types/ReInitPicComp.Types';
import { SEVERITY } from '../../utils/constantes/contantes';

interface PropsFromState {
    tabReserves: FicheAutocontroleTabReserves
}

interface PropsFromDispatch {
    generalInformations: GeneralInformationsState,
    isSaved: boolean,
    setIsSaved: Function,
    updateTabReserves: Function,
    updateIsTabReserves: Function,
    pictures: PictureState[],
    currentState: CurrentState,
    data: FicheAutocontrole,
    deletePicsFromStore: Function,
    initGoBackState: Function,
    updateMessageSnackBar: Function,
    oldPictures: Array<string>,
    deleteOldPicture: Function,
    reInitPicComp: Function,
    fetchData: Function,
    updateSynthese: Function,
    setGeneralInformationsState: Function
}

type AllProps = PropsFromState & PropsFromDispatch;

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        backdrop: {
            zIndex: theme.zIndex.drawer + 1,
            color: '#fff',
        },
    }),
);

const TabReservesAutocontrole: React.FC<AllProps> = ({ tabReserves, generalInformations, isSaved, setIsSaved, updateTabReserves, updateIsTabReserves, pictures, oldPictures, deleteOldPicture, data, deletePicsFromStore, initGoBackState, updateMessageSnackBar, reInitPicComp, fetchData, updateSynthese, setGeneralInformationsState }) => {

    /**
     * Constantes & State :
     */
    const classes = useStyles();
    const [loading, setLoading] = React.useState(false);

    const getAutocontrole = () => {
        API.getAutocontrole(generalInformations.trancheTravaux.id, generalInformations.typeAutocontrole)
            .then(function (response: any) {
                const ficheAutocontrole: FicheAutocontrole = response.data
                fetchData(ficheAutocontrole);
                updateSynthese(ficheAutocontrole.tabSynthese);
                setGeneralInformationsState(tabInfosToGeneralInformations(generalInformations, ficheAutocontrole.tabInfos));
            }).catch(function (error: any) {
                fetchData(null);
            });
    }

    const isValidTabReservesAutocontrole = () => {

        const uniqueLotNumbers = new Set(
            tabReserves.criterias
                .map(critere => critere.deliveryReserve?.lotNumber)
                .filter(lotNumber => lotNumber && lotNumber.trim() !== '')
        );

        if (uniqueLotNumbers.size < 3) {
            updateMessageSnackBar({
                messages: ["Il faut obligatoirement renseigner 3 logements"],
                severity: SEVERITY.ERROR
            });
            return false;
        }
        return true;
    }

    /**
     * API :
     */
    const savePage = () => {
        if (!isValidTabReservesAutocontrole()) {
            setLoading(false);
            return;
        }
        setLoading(true);
        updateTabReserves(tabReserves)
        API.updateAutocontrole(tabReserves, ProgressBarService.getComplitionPercent(data), data.statut)
            .then(() => {
                if (pictures.length > 0) {
                    const promises: any[] = [];
                    pictures.forEach(img => {
                        promises.push(uploadToS3(img.name, img.type, img.pic));
                    });

                    Promise.all(promises).then(
                        () => {

                            getAutocontrole();

                            console.log("Images sauvegardées !");
                            setIsSaved(true);
                            setLoading(false);
                            deletePicsFromStore();
                            reInitPicComp();
                        }, err => {
                            console.error(err);

                        });

                    if (oldPictures.length > 0) {
                        oldPictures.forEach(oldPic => {
                            API.deletePicFromS3(oldPic).then(() => {
                                console.log("Image supprimée : " + oldPic);
                                deleteOldPicture(oldPic);
                            }, err => {
                                console.error(err);
                            });
                        });
                    }
                } else {
                    getAutocontrole();
                }
                initGoBackState();
                console.log("Autocontrole sauvegardé 4");
                setIsSaved(true);
                setLoading(false);
            }).catch(() => {
                console.log("Problème lors de la sauvegarde");
                setIsSaved(true);
                setLoading(false);
            });
    }

    React.useEffect(() => {
        updateIsTabReserves(true);
    }, []);

    const saveCritere = (updatedCritere: FicheAutoControleCritere) => {
        const criterIndex = tabReserves.criterias.findIndex(c => c.id === updatedCritere.id);
        tabReserves.criterias[criterIndex] = updatedCritere;
        setIsSaved(false);
        updateTabReserves(tabReserves);
    }

    /**
     * Display :
     */
    return (
        <div className="tabReserves">
            <div className="tabReserves-informations">
                <div className="tabReserves-title">
                    <span className="tabReserves-title-text"></span>
                </div>
            </div>
            <div className="tabReserves-header">
                <div className="tabReserves-header-row-lot">
                    <span className="tabReserves-header-text"></span>
                </div>
                <div className="tabReserves-header-row-lot">
                    <span className="tabReserves-header-text">numéro de lot</span>
                </div>
                <div className="tabReserves-header-row-pre-delivery">
                    <span className="tabReserves-header-text">nombre de réserves<br /> identifiées en<br /> prélivraison</span>
                </div>
                <div className="tabReserves-header-row-remaining-pre-delivery">
                    <span className="tabReserves-header-text">nombre de réserves<br /> de prélivraisons non<br /> levées à la livraison</span>
                </div>
                <div className="tabReserves-header-row-new-delivery">
                    <span className="tabReserves-header-text">nombre de nouvelles<br /> réserves identifiées<br /> à la livraison</span>
                </div>
            </div>

            <div className="tabReserves-informations">
                {tabReserves.criterias.map((critere: FicheAutoControleCritere, idx: number) => (
                    <ReserveAutocontrole
                        key={critere.id || idx}
                        critere={critere}
                        updateCritere={saveCritere}
                    />
                ))}
            </div>

            <div className="tab-save-button-container">
                <Button disabled={isSaved} className={"tab-save-button-computer tab-save-button"} onClick={savePage}>Enregistrer</Button>
            </div>

            <Backdrop className={classes.backdrop} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );

}

const mapStateToProps = ({ ficheAutocontrole, generalInformations, pictures, oldPictures, currentState }: ApplicationState) => ({
    generalInformations: generalInformations,
    data: ficheAutocontrole.data,
    isSaved: ficheAutocontrole.isSaved,
    oldPictures: oldPictures,
    pictures: pictures,
    currentState: currentState
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    return {
        setIsSaved: (params: boolean) => dispatch({ type: FicheAutocontroleActionTypes.SET_ISSAVED, payload: params }),
        updateTabReserves: (data: FicheAutocontroleTabReserves) => dispatch({ type: FicheAutocontroleActionTypes.UPDATE_TAB_RESERVES, payload: data }),
        updateIsTabReserves: (params: boolean) => dispatch({ type: CurrentStateActions.IS_TABRESERVES, params: params }),
        deletePicsFromStore: () => dispatch({ type: PictureTypes.DELETE_ALL_PIC }),
        initGoBackState: () => dispatch({ type: GoBackCurrentStateActions.INIT_STATE }),
        deleteOldPicture: (name: string) => dispatch({ type: OldPictureTypes.DELETE_OLD_PIC, picName: name }),
        reInitPicComp: () => dispatch({ type: ReInitPicCompActions.RE_INIT }),
        updateMessageSnackBar: (params: MessagesAlertState) => dispatch({ type: MessagesAlertTypes.UPDATE_STATE, payload: params }),
        fetchData: (data: FicheAutocontrole) => dispatch({ type: FicheAutocontroleActionTypes.FETCH_DATA, payload: data }),
        updateSynthese: (data: TabSynthese) => dispatch({ type: TabSyntheseStateActions.UPDATE_STATE, payload: data }),
        setGeneralInformationsState: (params: GeneralInformationsState) => dispatch({ type: GeneralInformationsTypes.SET_GENERAL_INFORMATIONS, payload: params })
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TabReservesAutocontrole);